export const environment = {
  production: false,
  apiUrl:"https://api.merc.viveosrl.com/",
  baseUrl:"https://merc.viveosrl.com",
  version: "1.8.0"
};
